(ns app.ui.campaigns.campaign-components
  (:require ["/js/components/campaign/approval/ApprovalStatusFormPanelAlert" :default ApprovalStatusFormPanelAlert]
            ["/js/components/campaign/Incrementality" :default Incrementality]
            ["/js/services/campaign"            :as    svc]
            ["/js/components/campaign/CampaignsListView"          :default CampaignsListView]
            [app.crud                           :as    crud]
            [app.crypto                         :as    crypto]
            [app.routes                         :as    r  :refer [on-route-change]]
            [app.rpc                            :as    rpc]
            [app.ui.campaigns.approval          :as    approval]
            [app.ui.campaigns.duplicate         :as    cd]
            [app.ui.kevel-ui.utils.util         :refer [make-fetch-more]]
            [app.ui.status                      :as    st]
            [app.ui.version                     :as version]
            [cljstache.core                     :refer [render]]
            [geir.business-logic                :as    biz]
            [geir.constants                     :as    const]
            [hoplon.core
             :refer [a cond-tpl defelem div do-watch hr option span when-tpl]]
            [javelin.core
             :refer [cell cell= cell? defc formula-of]]
            [ui.button                          :as    button]
            [ui.component                       :as    component]
            [ui.filters                         :as    filters]
            [ui.form                            :as    form]
            [ui.form.custom-fields              :as    cf]
            [ui.form.input                      :as    input]
            [ui.helix-hoplon                    :as    helix-hoplon]
            [ui.icon                            :as    icon]
            [ui.link                            :as    link]
            [ui.paging                          :as    p]
            [ui.screen                          :as    screen]
            [ui.tooltip                         :as    tooltip]
            [ui.typeahead                       :as    typeahead]
            [ui.typeahead.typeahead-with-create :as    typeahead-with-create]
            [ui.util                            :as    util]
            [workflow.form                      :as    wform])
  (:require-macros [ui.form :refer [definput]]))

(def schema
  {:id                0
   :name              nil
   :brandid           nil
   :brandname         ""
   :customfields      nil
   :salespersonid     nil
   :captype           nil
   :dailycapamount    nil
   :lifetimecapamount nil
   :freqcap           nil
   :freqcaptype       0
   :freqcapduration   nil
   :dontaffectparentfreqcap nil
   :incrementality nil})

(defn- delivery-status
  [campaign]
  (st/delivery-status (select-keys campaign
                                   [:startdate :deliverystatus :isactive])))

(defn- approval-status-label
  [campaign]
  (let [approval-status (get-in campaign [:approvalstatus :Status])]
    (get const/campaign-approval-status-labels approval-status)))

(defn campaign-tooltip
  [campaign]
  (let [dstatus (st/delivery-status campaign)]
    (get const/campaign-delivery-status-messages dstatus)))

(defelem delete-modal [{:keys [deleting]} _]
  (crud/delete-modal
   :title       (cell= (render ~(rpc/from-lang-pack ::delete-modal-title)
                               {:campaignname (:__title__ deleting)}))
   :size        :md
   :button-txt  (rpc/from-lang-pack ::delete-modal-button-text)
   :description (rpc/from-lang-pack ::delete-modal-description)))

(definput typeahead
  [{:keys [advertiser] :as attr} _]
  (let [opts (merge {:display-fn :__title__ :value-fn :id} attr)]
    (if advertiser
      (let [{:keys [state display selected-display]
             :as manager} (typeahead/typeahead-manager opts)]

        (util/on-value (typeahead/cleared?-cell manager) true
                       (fn [_]
                         (reset! state (:id @advertiser))
                         (reset! display (:__title__ @advertiser))
                         (reset! selected-display (:__title__ @advertiser))))

        (typeahead/input* opts manager))
      (form/typeahead opts))))

(defc custom-fields-errors nil)

(defn wrap-campaign-upsert
  [upsert]
  (-> (fn [campaign & args]
        (doto ^js (apply upsert campaign args)
          (.fail #(reset! custom-fields-errors (ex-data %)))
          (.done #(reset! custom-fields-errors nil))))
      (with-meta (meta upsert))))

(defn prep-freqcaptype
  "Ensures the frequency cap type is an integer"
  [{:keys [freqcaptype] :as data}]
  (if (nil? freqcaptype)
    data
    (assoc data :freqcaptype (js/parseInt freqcaptype))))

(defelem upsert-form [{:keys [current-item advertiser redirect-on-new? page]}]
  (let [state     (cell nil)
        page      (or page screen/*page*)]
    (binding [screen/*upsert* (wrap-campaign-upsert (rpc/remote 'upsert-campaign! :state state))]
      (form/with-form [{:keys [data] :as form-machine} (form/upsert-machine
                                                        :success #(do
                                                                    (p/refresh! page)
                                                                    (when-not (= page rpc/campaigns)
                                                                      (p/refresh! rpc/campaigns))
                                                                    (when (util/str= "0" (:id @%))
                                                                      (when redirect-on-new?
                                                                        (set! js/window.location.hash
                                                                              (str "#!/campaign/" (get @state "Id") "/flights/"))))
                                                                    (reset! current-item nil)
                                                                    (reset! state nil))
                                                        :action-xform prep-freqcaptype)]
        (let [{:keys [id name brandid captype dailycapamount lifetimecapamount
                      freqcap freqcaptype freqcapduration incrementality]}
              data

              title
              (cell= (if (= id 0)
                       ~(rpc/from-lang-pack ::upsert-form-modal-title-new)
                       (render
                        ~(rpc/from-lang-pack ::upsert-form-modal-title-edit)
                        {:campaignname name})))

              selected-advertiser
              (cell= (or (:__title__ advertiser)
                         (and (not= 0 (:id current-item))
                              (:brandname current-item))))
              showfreqcap?
              (cell nil)

              campaign-approvals-enabled?
              approval/campaign-approvals-enabled?

              editable?
              (approval/campaign-editable? current-item)

              initial-incrementality
              (cell= (:incrementality current-item))

              incrementality-panel-expanded?
              (cell nil)]
          (do-watch current-item #(do
                                    (if-not (and (util/nil-or-zero? (:freqcap %2))
                                                 (util/nil-or-zero? (:freqcapduration %2)))
                                      (reset! showfreqcap? true)
                                      (reset! showfreqcap? false))
                                    (when (util/nil-or-zero? (:captype %2))
                                      (reset! dailycapamount nil)
                                      (reset! lifetimecapamount nil))

                                    (if-not (or (util/nil-or-zero? (:incrementality %2))
                                                (empty? (:incrementality %2)))
                                      (reset! incrementality-panel-expanded? true)
                                      (reset! incrementality-panel-expanded? false))))
          (when (cell? advertiser)
            (do-watch advertiser #(reset! brandid (:id %2))))
          (form/modal-form
           :adzerk-logical-id "campaign-form"
           :size :md
           :title title
           :description (rpc/from-lang-pack ::upsert-form-modal-description)
           (form/upsert-form
            :submit-attr {:adzerk-logical-id "campaign-form-input-submit-button"
                          :disabled          (cell= (not editable?))}
            (form/panel
             :heading (rpc/from-lang-pack ::upsert-form-panel-campaign-settings-heading)
             (formula-of
              [campaign-approvals-enabled?
               current-item]
              (when
               (and campaign-approvals-enabled?
                    current-item)
                (helix-hoplon/mount-react
                 ApprovalStatusFormPanelAlert
                 {:campaign (clj->js current-item)})))
             (form/with-field :brandid
               (form/validation-field
                (form/label
                 (cell=
                  (if selected-advertiser
                    ~(rpc/from-lang-pack ::upsert-form-field-brandid-selected)
                    ~(rpc/from-lang-pack ::upsert-form-field-brandid-not-selected))))
                (typeahead
                 :adzerk-logical-id "campaign-form-advertiser-typeahead"
                 :disabled (cell= (not= 0 (:id current-item)))
                 :display-fn :title
                 :selected-display-fn :title
                 :rpc (typeahead/rpc 'advertisers)
                 :advertiser advertiser
                 :initial-display selected-advertiser
                 :results (typeahead-with-create/results-with-create
                           :rpc (rpc/remote 'create-advertiser-return-new!)
                           :attr-for-query :title
                           :data {:isactive true}))
                (form/validation-message)))

             (form/with-field :name
               (form/validation-field
                (form/label (rpc/from-lang-pack ::upsert-form-field-name-label))
                (form/text-input
                 :adzerk-logical-id "campaign-form-input-name"
                 :focus-select current-item
                 :placeholder  (rpc/from-lang-pack ::upsert-form-field-name-placeholder))
                (form/validation-message)))

             (form/with-field :salespersonid
               (form/validation-field
                (form/label (rpc/from-lang-pack ::upsert-form-field-salespersonid-label))
                (form/typeahead
                 :adzerk-logical-id "campaign-form-salesperson-typeahead"
                 :rpc rpc/salespeople
                 :display-fn :name
                 :initial-display (cell= (:salespersonname current-item))
                 :data-dd-privacy "hidden")
                (form/validation-message)))

             (do
               ;; The only type of cap (at least, in terms of CapType,
               ;; DailyCapAmount and LifetimeCapAmount) supported on
               ;; campaigns is Revenue.
               ;;
               ;; So, whenever DailyCapAmount or LifetimeCapAmount has a
               ;; value, set CapType to Revenue. Otherwise, set it to null.
               (util/on-change
                (cell= [dailycapamount lifetimecapamount])
                (fn [[dailycapamount lifetimecapamount]]
                  (reset! captype
                          (when (or dailycapamount lifetimecapamount)
                            const/CAP-TYPE-REVENUE))))

               (div
                (form/checkbox-containing-input
                 :label         (rpc/from-lang-pack
                                 ::upsert-form-field-dailyrevenuecap-label)
                 :checkbox-attr {:adzerk-logical-id
                                 "campaign-form-checkbox-dailycapamount"}
                 :input-elem    form/number-input
                 :input-attr    {:adzerk-logical-id
                                 "campaign-form-input-dailycapamount"

                                 :min
                                 0}
                 :default-value 0
                 :state         dailycapamount
                 :entity-id     id
                 :field-key     :dailycapamount
                 :inline?       true)

                (form/checkbox-containing-input
                 :label         (rpc/from-lang-pack
                                 ::upsert-form-field-lifetimerevenuecap-label)
                 :checkbox-attr {:adzerk-logical-id
                                 "campaign-form-checkbox-lifetimecapamount"}
                 :input-elem    form/number-input
                 :input-attr    {:adzerk-logical-id
                                 "campaign-form-input-lifetimecapamount"

                                 :min
                                 0}
                 :default-value 0
                 :state         lifetimecapamount
                 :entity-id     id
                 :field-key     :lifetimecapamount
                 :inline?       true)))

             (rpc/when-feature :isCampaignAdvertiserFreqCap
                               (form/checkbox-containing-inputs
                                :checkbox    {:label         (rpc/from-lang-pack ::upsert-form-field-enablefreqcap-label)
                                              :checkbox-attr {:adzerk-logical-id
                                                              "campaign-form-checkbox-showfreqcap"}
                                              :state         showfreqcap?
                                              :field-key     :showfreqcap?}

                                :input-attrs [{:input-elem form/number-input
                                               :input-attr {:adzerk-logical-id "campaign-form-input-freqcap"
                                                            :min 1
                                                            :state freqcap}
                                               :field-key  :freqcap
                                               :pre-text   (rpc/from-lang-pack ::upsert-form-field-enablefreqcap-text-1)}

                                              {:input-elem form/number-input
                                               :input-attr {:adzerk-logical-id "campaign-form-input-freqcapduration"
                                                            :min 1
                                                            :state freqcapduration}
                                               :field-key  :freqcapduration
                                               :pre-text   (rpc/from-lang-pack ::upsert-form-field-enablefreqcap-text-2)}

                                              {:input-elem form/select
                                               :input-attr {:adzerk-logical-id
                                                            "campaign-form-input-freqcaptype"
                                                            :state freqcaptype}
                                               :field-key  :freqcaptype
                                               :input-options [(option {:value 3 :selected (cell= (= freqcaptype 3))} (rpc/from-lang-pack ::upsert-form-field-freqcapduration-minutes-option))
                                                               (option {:value 1 :selected (cell= (#{0 1} freqcaptype))} (rpc/from-lang-pack ::upsert-form-field-freqcapduration-hours-option))
                                                               (option {:value 2 :selected (cell= (= freqcaptype 2))} (rpc/from-lang-pack ::upsert-form-field-freqcapduration-days-option))]}]

                                :entity-id   id
                                :inline?     false))

             (rpc/when-feature :isCampaignAdvertiserFreqCap
                               (form/with-field :dontaffectparentfreqcap
                                 (form/validation-item
                                  (form/inline-checkbox :adzerk-logical-id "campaign-form-checkbox-dontaffectparentfreqcap")
                                  (form/label (rpc/from-lang-pack ::upsert-form-field-dontaffectparentfreqcap-label))
                                  (form/validation-message))))

             (div
              :class "panel-notice"
              :toggle dailycapamount
              (rpc/from-lang-pack ::campaign-timezone-caps-notice))

             (hr :style "margin: 2em 0")

             (form/with-field :customfields
               (cf/custom-fields
                :spec         (cell= (:fields (:mediaPlan rpc/custom-fields)))
                :fm           form-machine
                :data         form/*input-data*
                :input-errors custom-fields-errors)))

            (rpc/when-feature
             :campaignsIncrementality
             (form/panel
              :heading (rpc/from-lang-pack ::upsert-form-panel-campaign-incrementality-heading)
              :is-collapsible true
              :is-expanded incrementality-panel-expanded?
              (div
               :class  "alert alert-info"
               (div
                (rpc/from-lang-pack ::upsert-form-panel-campaign-incrementality-alert)
                (a
                 :style
                 "margin-left: .5em;"

                 :adzerk-logical-id
                 "campaing-incrementality-help-topic-link"

                 :href
                 "https://dev.kevel.com/docs/incrementality"

                 :target
                 "_blank"

                 :aria-label
                 (rpc/from-lang-pack
                  ::upsert-form-panel-campaign-incrementality-help-message-aria-label)

                 (rpc/from-lang-pack
                  ::upsert-form-panel-campaign-incrementality-help-message))))
              (form/with-field :incrementality
                (let [error-cell form/*input-error*]
                  (form/validation-field
                   (formula-of
                    ;; we have `id` here so that it's re-rendered when it changes
                    [initial-incrementality error-cell id]
                    (helix-hoplon/mount-react
                     Incrementality
                     (clj->js {:initialIncrementality initial-incrementality
                               :onChange #(reset! incrementality (js->clj % {:keywordize-keys true}))
                               :error error-cell})))
                   (form/validation-message)))))))))))))

(defc show-end-date-column-tooltip false)
(defc end-date-column-tooltip-top 0)
(defc end-date-column-tooltip-left 0)

(defc show-ctr-column-tooltip false)
(defc ctr-column-tooltip-top 0)
(defc ctr-column-tooltip-left 0)

(defelem campaign-end-date-column-tooltip
  [{:keys [container]} _]
  (tooltip/column-tooltip  :show show-end-date-column-tooltip
                           :container container
                           :top  end-date-column-tooltip-top
                           :left end-date-column-tooltip-left
                           :words (rpc/from-lang-pack ::campaign-date-explainer-text)))

(defelem campaign-ctr-column-tooltip
  [{:keys [container]} _]
  (tooltip/column-tooltip  :show show-ctr-column-tooltip
                           :container container
                           :top  ctr-column-tooltip-top
                           :left ctr-column-tooltip-left
                           :words (rpc/from-lang-pack ::campaign-counts-explainer-text)))

(defn report-prefill-base64 [{:keys [id startdate enddate] :as stuff}]
  (let [report-config {:Request
                       {:Start startdate
                        :End enddate
                        :TimeZone "UTC"
                        :TimePeriod "day"
                        :Parameters [{:campaignId id}]
                        :GroupBy ["flightId"]}}
        report-config-json (clj->js report-config)]
    (crypto/string->base64-string (.stringify js/JSON report-config-json))))

(defn cancel-campaign-approval
  [campaign]
  (when campaign
    (rpc/tmp-flash-message! @(rpc/from-lang-pack ::campaign-columns-button-cancelling-approval))
    (-> (svc/cancelCampaignApproval (clj->js {:CampaignId (:id campaign)}))
        (.then (fn []
                 (p/refresh! rpc/campaigns)
                 (p/refresh! rpc/advertiser-campaigns)))
        (.catch (fn [error]
                  (rpc/tmp-flash-message! error))))))

(defn campaign-columns
  "Allows you to toggle the advertiser column with show-advertiser"
  [{:keys [current-item deleting-item page show-advertiser]}]
  (filter identity
          [(crud/custom-column
            :name    (rpc/from-lang-pack ::campaign-columns-isactive-label)
            :key     :isactive
            :elem-fn #(let [approval-status    (cell= (get-in % [:approvalstatus :Status]))
                            approved?          (cell= (or
                                                       (and (not (:isactive %))
                                                            (= approval-status const/APPROVAL_STATUS_ACTIVATE_APPROVED))
                                                       (and (:isactive %)
                                                            (= approval-status const/APPROVAL_STATUS_DEACTIVATE_APPROVED))))
                            disable-toggle?    (cell= (and approval/campaign-approvals-enabled?
                                                           (not approved?)))
                            handle-toggle      (rpc/toggle-handler 'set-campaign-activeness! % page)
                            text               (cell=
                                                (if (:isactive %)
                                                  (rpc/from-lang-pack ::campaign-columns-isactive-deactivate-requires-approval)
                                                  (rpc/from-lang-pack ::campaign-columns-isactive-activate-requires-approval)))]
                        (formula-of
                         [disable-toggle?
                          text]
                         (input/toggle
                          :adzerk-logical-class "campaign-active-toggle"

                          :state
                          (cell= (:isactive %) identity)

                          :tooltip-top
                          (when disable-toggle? text)

                          :style
                          (when disable-toggle? "cursor: help;")

                          :click
                          (fn []
                            (when-not disable-toggle?
                              (handle-toggle)))))))

           (crud/custom-column
            :name    (rpc/from-lang-pack ::campaign-columns-approval-status-label)
            :key     :approvalstatus
            :toggle  (cell= (:isCampaignApprovals rpc/feature-flags))
            :elem-fn #(let [approval-status-comment (cell= (get-in % [:approvalstatus :Comment]))]
                        (span
                         :adzerk-logical-class "campaign-approval-status"
                         (rpc/from-lang-pack (cell= (approval-status-label %)))
                         " "
                         (when-tpl
                          approval-status-comment
                          (icon/info
                           :class "tooltip-trigger"
                           :tooltip-top approval-status-comment)))))

           (crud/data-column
            :adzerk-logical-class
            "campaign-name"

            :name
            (rpc/from-lang-pack ::campaign-columns-name-label)

            :key
            :name

            :href
            #(str "#!/" @rpc/networkid "/campaign/" (:id %) "/flights/"))

           (crud/data-column
            :name (rpc/from-lang-pack ::campaign-columns-id-label)
            :key  :id)

           (crud/data-column
            :name  (rpc/from-lang-pack ::campaign-columns-startdate-label)
            :key   :startdate
            :can-sort? (cell= (not rpc/network-too-large))
            :value #(util/format-date "M/D/YYYY" (:startdate %) @rpc/default-timezone))

           (crud/data-column
            :name        (rpc/from-lang-pack ::campaign-columns-enddate-label)
            :header-xtra (tooltip/column-tooltip-anchor
                          :show show-end-date-column-tooltip
                          :top  end-date-column-tooltip-top
                          :left end-date-column-tooltip-left)
            :key         :enddate
            :can-sort?   (cell= (not rpc/network-too-large))
            :value       #(util/format-date "M/D/YYYY" (:enddate %) @rpc/default-timezone))

           (crud/custom-column
            :name    (rpc/from-lang-pack ::campaign-columns-status-label)
            :key     :progress
            :toggle  (cell= (not (:hideDeliveryStatus rpc/feature-flags)))
            :elem-fn (fn [campaign]
                       (component/progress-status
                        :trackable   (cell= true)
                        :status      (cell= (const/delivery-status-class (delivery-status campaign)))
                        :progress    nil
                        :tooltip-top (rpc/from-lang-pack (cell= (campaign-tooltip campaign))))))

           (crud/data-column
            :name  (rpc/from-lang-pack ::campaign-columns-impressions-label)
            :key   :impressions
            :value #(if-let [impressions (-> % :instantcounts :impressions)]
                      (util/format-number-truncate impressions)
                      "—"))

           (crud/data-column
            :name  (rpc/from-lang-pack ::campaign-columns-clicks-label)
            :key   :clicks
            :value #(if-let [clicks (-> % :instantcounts :clicks)]
                      (util/format-number-truncate clicks)
                      "—"))

           (crud/data-column
            :name   (rpc/from-lang-pack ::campaign-columns-uniqueclicks-label)
            :toggle (cell= (:clickBucketing rpc/feature-flags))
            ;; absence of :key prevents us from sorting on this column
            :value #(if-let [uniqueclicks (-> % :instantcounts :uniqueclicks)]
                      (util/format-number-truncate uniqueclicks)
                      "—"))

           (crud/data-column
            :name  (rpc/from-lang-pack ::campaign-columns-conversions-label)
            :value #(if-let [conversions (-> % :instantcounts :conversions)]
                      (util/format-number-truncate conversions)
                      "—"))

           (crud/data-column
            :name  (rpc/from-lang-pack ::campaign-columns-revenue-label)
            :value #(if-let [revenue (-> % :instantcounts :revenue)]
                      (util/format-currency revenue)
                      "—"))

           (crud/data-column
            :name        (rpc/from-lang-pack ::campaign-columns-ctr-label)
            :header-xtra (tooltip/column-tooltip-anchor
                          :show show-ctr-column-tooltip
                          :top  ctr-column-tooltip-top
                          :left ctr-column-tooltip-left)
            :key         :ctr
            :value       #(if-let [ctr (-> % :instantcounts :ctr)]
                            (str (util/format "%.2f" (* ctr 100)) \%)
                            "—"))

           (crud/data-column
            :name (rpc/from-lang-pack ::campaign-columns-gmv-label)
            :value #(if-let [gmv (-> % :instantcounts :gmv)]
                      (util/format-currency gmv)
                      "—"))
           (crud/data-column
            :name  (rpc/from-lang-pack ::campaign-columns-roas-label)
            :value #(let [{:keys [gmv revenue]} (:instantcounts %)]
                      (if-let [roas (biz/roas gmv revenue)]
                        (str (js/Math.round (* roas 100)) \%)
                        "—")))
           (when show-advertiser
             (crud/data-column
              :name    (rpc/from-lang-pack ::campaign-columns-advertiser-label)
              :key     :brandname
              :href    #(str "#!/" @rpc/networkid "/advertiser/" (:brandid %) "/campaigns/")))

           (crud/custom-column
            :elem-fn
            #(let [approval-status             (cell= (get-in % [:approvalstatus :Status]))
                   last-action-by-user-id      (cell= (get-in % [:approvalstatus :LoginId]))
                   can-request-approval?       (cell= (or (nil? approval-status)
                                                          (= approval-status const/APPROVAL_STATUS_ACTIVATE_REJECTED)
                                                          (= approval-status const/APPROVAL_STATUS_DEACTIVATE_REJECTED)))
                   disable-delete?             (cell= (or (not rpc/user-is-editor?)
                                                          (and approval/campaign-approvals-enabled?
                                                               (or (:isactive %)
                                                                   (not can-request-approval?)))))]
               (button/group
                (form/edit-icon :current current-item :item %)
                (when-tpl
                 rpc/user-is-editor?
                 (form/delete-icon
                  :deleting deleting-item
                  :item     %
                  :disabled disable-delete?))
                (button/options-dropdown
                 :align "right"
                 :adzerk-logical-class "options-menu-button"
                 (cond-tpl
                  ;; Request to activate/deactivate
                  (cell= (and rpc/user-is-editor?
                              approval/campaign-approvals-enabled?
                              can-request-approval?))
                  (link/button-link
                   :adzerk-logical-class "submit-for-approval-button"
                   :click (fn [] (approval/select-campaign @%))
                   (rpc/from-lang-pack ::campaign-columns-button-submit-for-approval))

                  ;; Cancel request to activate/deactivate
                  (cell= (and rpc/user-is-editor?
                              approval/campaign-approvals-enabled?
                              (or (= approval-status const/APPROVAL_STATUS_ACTIVATE_REQUESTED)
                                  (= approval-status const/APPROVAL_STATUS_DEACTIVATE_REQUESTED))
                              (= (:id rpc/user) last-action-by-user-id)))
                  (link/button-link
                   :adzerk-logical-class "cancel-approval-button"
                   :click (fn [] (cancel-campaign-approval @%))
                   (rpc/from-lang-pack ::campaign-columns-button-cancel-approval))

                  ;; Approve or reject request to activate/deactivate
                  (cell= (and rpc/user-is-editor?
                              approval/campaign-approvals-enabled?
                              (or (= approval-status const/APPROVAL_STATUS_ACTIVATE_REQUESTED)
                                  (= approval-status const/APPROVAL_STATUS_DEACTIVATE_REQUESTED))
                              (not= (:id rpc/user) last-action-by-user-id)))
                  (link/button-link
                   :adzerk-logical-class "approve-button"
                   :click (fn [] (approval/select-campaign @%))
                   (rpc/from-lang-pack ::campaign-columns-button-approve)))
                 (when-tpl
                  rpc/user-is-editor?
                  (link/button-link
                   :adzerk-logical-class "duplicate-campaign-button"
                   :click (fn [] (cd/select-campaign @%)) ; ???
                   (rpc/from-lang-pack ::campaign-columns-button-duplicate)))
                 (link/button-link
                  :href (cell= (str "#!/" rpc/networkid "/campaign/" (:id %) "/ad-code/"))
                  (rpc/from-lang-pack ::campaign-columns-button-adcode))
                 (link/button-link
                  :click (fn []
                           (set! js/window.location.hash
                                 (str "#!/" @rpc/networkid "/reports/new/" (report-prefill-base64 @%))))
                  (rpc/from-lang-pack ::campaign-columns-button-viewreport))))))]))

(def filter-types
  (cell=
   {:__title__      (if rpc/network-too-large
                      :prefix-search
                      :like)
    :id             :=
    :brandid        :=
    :salespersonid  :=
    :isactive       :=
    :deliverystatus :=}))

(defelem campaign-filters [{:keys [page current-entity]} _]
  (form/with-form
    [form-machine (filters/filter-form-machine
                   :filter-types
                   filter-types

                   :filter-transform
                   (fn [filter-values]
                     (into
                      {}
                      (filter (fn [[k v]]
                                (and
                                 (or (not= :id k)
                                     (biz/valid-numeric-id? v))
                                 (not= "All" v))))
                      filter-values))

                   :page
                   page)]
    (when (cell? current-entity)
      (do-watch current-entity #(when %2
                                  (let [brandid   (-> form-machine :data :brandid)]
                                    (reset! brandid (:id %2))))))
    (let [reset-filters!    #(do
                               (wform/reset form-machine)
                               (when (cell? current-entity)
                                 (reset! (-> form-machine :data :brandid) (:id @current-entity))))]
      (on-route-change reset-filters!)
      (filters/filters
       (form/with-field :__title__
         (div
          (form/label
           (rpc/from-lang-pack
            (cell= (if rpc/network-too-large
                     ::campaign-filters-field-title-starts-with-label
                     ::campaign-filters-field-title-label))))
          (form/text-input :debounce-ms util/DEFAULT-DEBOUNCE-MS
                           :adzerk-logical-id "campaign-filters-title")))

       (form/with-field :id
         (div
          (form/label (rpc/from-lang-pack ::campaign-filters-field-id-label))
          (form/id-input :debounce-ms util/DEFAULT-DEBOUNCE-MS)))

       (form/with-field :brandid
         (div
          (form/label (rpc/from-lang-pack ::campaign-filters-field-brandid-label))
          (form/typeahead :rpc (typeahead/rpc 'advertisers))))

       (form/with-field :salespersonid
         (div
          (form/label (rpc/from-lang-pack ::campaign-filters-field-salespersonid-label))
          (form/typeahead :rpc (typeahead/rpc 'salespeople)
                          :adzerk-logical-id "salesperson-typeahead"
                          :data-dd-privacy "hidden")))

       (form/with-field :isactive
         (div
          (form/label (rpc/from-lang-pack ::campaign-filters-field-isactive-label))
          (form/select
           (option :value "All" (rpc/from-lang-pack ::campaign-filters-field-isactive-option-nil))
           (option :value true  (rpc/from-lang-pack ::campaign-filters-field-isactive-option-active))
           (option :value false (rpc/from-lang-pack ::campaign-filters-field-isactive-option-inactive)))))

       (form/with-field :deliverystatus
         (div
          (form/label (rpc/from-lang-pack ::campaign-filters-field-deliverystatus-label))
          (form/select
           (option :value "All"   (rpc/from-lang-pack ::campaign-filters-field-deliverystatus-option-nil))
           (option :value 0       (rpc/from-lang-pack ::campaign-filters-field-deliverystatus-option-0))
           (option :value 1       (rpc/from-lang-pack ::campaign-filters-field-deliverystatus-option-1))
           (option :value 2       (rpc/from-lang-pack ::campaign-filters-field-deliverystatus-option-2))
           (option :value 3       (rpc/from-lang-pack ::campaign-filters-field-deliverystatus-option-3))
           (option :value 4       (rpc/from-lang-pack ::campaign-filters-field-deliverystatus-option-4))
           (option :value 5       (rpc/from-lang-pack ::campaign-filters-field-deliverystatus-option-5)))))
       (div
        :style "margin-top: 32px;"
        (button/secondary
         :text (rpc/from-lang-pack ::campaign-filters-button-reset)
         :click reset-filters!))))))


(def fetch-more-advertisers-memo
  (memoize
   (fn [remote-advertisers]
     (make-fetch-more remote-advertisers))))

(def fetch-more-salespeople-memo
  (memoize
   (fn [remote-salespeople]
     (make-fetch-more remote-salespeople))))


(defelem app [{:keys [new-btn-txt page zone advertiser current-item deleting-item show-advertiser] :as opts} _kids]
  (let [zone            (or zone ::tabular-data-page-zone-title)
        container-id    (str (gensym))
        campaigns (:data page)
        campaigns-loading (cell= (boolean (seq ~(:fetching page))))
        network-too-large? (util/safe-deref rpc/network-too-large)
        pagination-model (cell {:page 0 :pageSize 25})
        reset-filters! #(when (or (nil? advertiser) @advertiser)
                          (reset! pagination-model {:page 0 :pageSize 25})
                          (swap! (:params page)
                                 assoc
                                 :filters (if (and advertiser @advertiser)
                                            {:brandid (filters/attr-spec := (:id @advertiser))}
                                            {})
                                 :sorting {:by :id :order :desc}
                                 :current-page 1))]

    (on-route-change reset-filters!)

    (if version/new-version?
      (component/new-app
       (helix-hoplon/mount-react-js CampaignsListView {:showAdvertiser show-advertiser
                                                       :featureFlags rpc/feature-flags
                                                       :networkTooLarge network-too-large?
                                                       :title (rpc/from-lang-pack zone (cell= {:brandname (:__title__ advertiser)}))
                                                       :titleLoading (cell= (boolean (and (not= zone ::tabular-data-page-zone-title)
                                                                                          (nil? (:__title__ advertiser)))))
                                                       :data (cell= (clj->js (or campaigns [])))
                                                       :loading campaigns-loading
                                                       :onToggleActive (fn [row]
                                                                         ((rpc/toggle-handler 'set-campaign-activeness!
                                                                                              (cell (js->clj row :keywordize-keys true))
                                                                                              page)))
                                                       :onDuplicateCampaign (fn [row] (cd/select-campaign (js->clj row :keywordize-keys true)))
                                                       :onEdit (fn [row] (reset! current-item (js->clj row :keywordize-keys true)))
                                                       :onDelete (fn [row] (reset! deleting-item (js->clj row :keywordize-keys true)))
                                                       :onNewCampaign (fn [] (reset! current-item schema))
                                                       :isEditor rpc/user-is-editor?
                                                       :onRefresh #(p/refresh! page)
                                                       :onFilterChange
                                                       (fn [raw-js-filters]
                                                         (let [raw-filters  (js->clj raw-js-filters :keywordize-keys true)
                                                               cleaned      (into {}
                                                                                  (filter (fn [[k v]]
                                                                                            (and
                                                                                             (or (not= :id k)
                                                                                                 (biz/valid-numeric-id? v))
                                                                                             (not= "All" v))))
                                                                                  raw-filters)
                                                               filter-types*  {:__title__      (if network-too-large?
                                                                                                 :prefix-search
                                                                                                 :like)
                                                                               :id             :=
                                                                               :brandid        :=
                                                                               :salespersonid  :=
                                                                               :isactive       :=
                                                                               :deliverystatus :=}
                                                               ;; Convert raw → CLJ filter spec from user input
                                                               spec            (filters/filter-spec cleaned filter-types*)
                                                               current-filters (:filters @(:params page))
                                                               effective-spec  (cond
                                                                                 ;; Advertiser loaded — preserve existing brandid to avoid
                                                                                 ;; string/number type mismatch with reset-filters!
                                                                                 (and advertiser @advertiser)
                                                                                 (assoc spec :brandid (or (:brandid current-filters)
                                                                                                          (filters/attr-spec := (:id @advertiser))))
                                                                                 ;; Advertiser prop exists but not yet loaded — skip update
                                                                                 ;; to prevent clearing the brandid set by reset-filters!
                                                                                 advertiser
                                                                                 nil
                                                                                 ;; No advertiser (all campaigns) — use spec as-is
                                                                                 :else spec)]

                                                           (when (and effective-spec (not= effective-spec current-filters))
                                                             (swap! (:params page)
                                                                    assoc
                                                                    :filters effective-spec
                                                                    :current-page 1))))
                                                       ;; Server-side sorting (MUI DataGrid sort model -> CLJ sorting spec)
                                                       :onSortModelChange (fn [model] ;; {field: 'fieldname', sort: 'asc' | 'dsc'}
                                                                            (let [clj-sort-model  (js->clj model :keywordize-keys true)
                                                                                  sort-model (first clj-sort-model)
                                                                                  field      (:field sort-model)
                                                                                  order      (:sort sort-model)
                                                                                  sorting    (if (and field order)
                                                                                               {:by    (keyword field)
                                                                                                :order (keyword order)}
                                                                                               {:by :id :order :desc})
                                                                                  current-sorting (:sorting @(:params page))]
                                                                              (when (not= sorting current-sorting)
                                                                                (swap! (:params page)
                                                                                       (fn [params]
                                                                                         (-> params
                                                                                             (assoc :current-page 1 :sorting sorting)))))))
                                                       ;; Keep DataGrid UI in sync with current sorting
                                                       :sortModel (cell= (clj->js (let [{:keys [by order]} ~(:sorting page)]
                                                                                    (if (and by order)
                                                                                      [{:field (name by) :sort (name order)}]
                                                                                      []))))
                                                       ;; Server Side Pagination 
                                                       :rowCount (cell= (or ~(:total-rows page) 0))
                                                       :paginationModel (cell= (clj->js pagination-model))
                                                       :onPaginationModelChange (fn [model]
                                                                                  (let [clj-model (js->clj model :keywordize-keys true)
                                                                                        page-idx (:page clj-model)
                                                                                        page-size (:pageSize clj-model)]
                                                                                    (reset! pagination-model clj-model)
                                                                                    (swap! (:params page)
                                                                                           assoc
                                                                                           :page-size page-size
                                                                                           :current-page (inc (or page-idx 0)))))
                                                       :fetchMoreAdvertisers (fetch-more-advertisers-memo (rpc/remote 'advertisers))
                                                       :fetchMoreSalespeople (fetch-more-salespeople-memo (rpc/remote 'salespeople))}))
      (component/app
       (approval/approval-modal)
       (apply crud/tabular-data-page
              :table-attrs      {:adzerk-logical-id "campaigns-table"}
              :row-attrs        {:adzerk-logical-class "campaign-data-row"}
              :pagination-attrs {:adzerk-logical-id "campaigns-table-pagination"}
              :sidebar-attrs    {:adzerk-logical-id "campaigns-table-sidebar"}
              :container-id container-id
              :after-data-table [(campaign-end-date-column-tooltip :container container-id)
                                 (campaign-ctr-column-tooltip :container container-id)]
              :new-btn-txt new-btn-txt
              :no-new-btn? (cell= (not rpc/user-is-editor?))
              :zone-title (rpc/from-lang-pack zone (cell= {:brandname (:__title__ advertiser)}))
              :region-title (rpc/from-lang-pack ::tabular-data-page-region-title)
              :secondary (campaign-filters :page page :current-entity advertiser)
              (campaign-columns opts))))))